// Sostituisci questi link con i tuoi profili ufficiali.
export const LINKS = {
  spotify: "https://open.spotify.com/artist/2WvAPIh8SCw7Xa3Z4MWKiw",
  appleMusic: "https://music.apple.com/",
  youtube: "https://www.youtube.com/",
  instagram: "https://www.instagram.com/",
  tiktok: "https://www.tiktok.com/",
  spotifyEmbed: "https://open.spotify.com/embed/artist/2WvAPIh8SCw7Xa3Z4MWKiw?utm_source=generator&theme=0",
  appStore: "",
  googlePlay: "",
};

// Data provvisoria di lancio di InkMaster (modificabile).
export const APP_LAUNCH = "2026-10-26T18:00:00+01:00";

const U = "?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600";

const A = "https://customer-assets-rejwkqb3.emergentagent.net/job_sfushop-official/artifacts/";

export const IMAGES = {
  hero: A + "hz5dldxf_IMG_0202.jpeg",
  bio: A + "ojtwl1no_IMG_0110.jpeg",
  studioCollage: A + "s62rl4tk_IMG_0171.jpeg",
  studioGuitar: A + "bilnr1e5_IMG_0170.jpeg",
  studioMic: A + "y7o9bw1e_IMG_0178.jpeg",
  tattoo: "https://images.unsplash.com/photo-1759247943108-39e23e97fde4" + U,
};

const INK = "/inkmaster/";

export const INK_ART = {
  mic: INK + "mic-bone.webp",
  machine: INK + "machine-bone.webp",
  panther: INK + "panther-bone.webp",
  skull: INK + "skull-bone.webp",
  moth: INK + "moth-bone.webp",
  koi: INK + "koi-bone.webp",
  packCover: INK + "flash-pack-cover.webp",
  packSheet: INK + "flash-pack-sheet.webp",
};

// Schermate dell'app nel mockup. "image" = screenshot reale (verticale ~9:20).
// Se "image" è vuoto viene mostrata la schermata disegnata: basta incollare l'URL dello screenshot per sostituirla.
export const APP_SCREENS = [
  { id: "campagna", label: "Campagna", image: "", caption: "Livelli guidati da apprendista a tatuatore: dalle prime linee agli stili complessi, sblocchi un livello alla volta." },
  { id: "studio", label: "Studio", image: A + "dnnob6rc_2e595b4e-f723-48a6-a08d-94f69c49798e.jpeg", caption: "Impara l'arte del tatuaggio con livelli guidati, prova qualsiasi disegno sulla pelle con la fotocamera AR e crea nuovi flash con l'IA." },
  { id: "ar", label: "Prova AR", image: A + "xk9p5nt5_c33d8e53-90bb-4751-8e1c-93ffccf6f4f2.jpeg", caption: "Scatta una foto del braccio o caricala dalla galleria, poi posiziona il disegno: vedi il tatuaggio sulla tua pelle prima di farlo." },
  { id: "shop", label: "Shop", image: A + "dgaufhc6_66e8ca75-7ee7-423d-a349-8c93ca3d7e1e.jpeg", caption: "Guadagna con i clienti del tuo studio e investi in macchine, aghi e inchiostri: ogni attrezzo migliora precisione e ombre." },
  { id: "ia", label: "Generatore IA", image: "", caption: "Descrivi l'idea del cliente, scegli lo stile e l'IA disegna nuovi flash unici, pronti da provare sulla pelle." },
];

// Il contatore della lista InkMaster mostra il numero solo da questa soglia in su (0 = sempre visibile).
export const WAITLIST_MIN = 50;

export const STREAMING = [
  { id: "spotify", testid: "spotify-external-link", name: "Spotify", icon: "fa-brands fa-spotify", href: LINKS.spotify, note: "Singoli, playlist e tutto quello che esce" },
  { id: "apple", testid: "apple-music-link", name: "Apple Music", icon: "fa-brands fa-apple", href: LINKS.appleMusic, note: "Alta qualità, anche offline" },
  { id: "youtube", testid: "youtube-link", name: "YouTube", icon: "fa-brands fa-youtube", href: LINKS.youtube, note: "Video, visual e dietro le quinte" },
];

export const SIZE_GUIDES = {
  hoodie: {
    fit: "Unisex · vestibilità regular",
    columns: ["Taglia", "Petto (cm)", "Lunghezza (cm)", "Manica (cm)"],
    rows: [
      ["S", "54", "68", "61"],
      ["M", "57", "71", "62"],
      ["L", "60", "74", "63"],
      ["XL", "63", "76", "64"],
      ["XXL", "66", "78", "65"],
    ],
    note: "Misure del capo steso in piano: il petto è misurato da ascella ad ascella. Sei tra due taglie o vuoi un fit oversize? Prendi quella più grande.",
  },
};

// Dati del venditore: completali prima di andare live.
export const LEGAL = {
  owner: "[Nome e cognome o ragione sociale]",
  vat: "[Partita IVA o codice fiscale]",
  address: "[Indirizzo completo]",
  email: "infosfushop@gmail.com",
  updated: "Settembre 2026",
};

export const formatPrice = (n) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n);

export const SHIP_COUNTRIES = [
  ["IT", "Italia"], ["SM", "San Marino"], ["VA", "Città del Vaticano"], ["CH", "Svizzera"], ["FR", "Francia"], ["DE", "Germania"], ["AT", "Austria"],
  ["ES", "Spagna"], ["PT", "Portogallo"], ["BE", "Belgio"], ["NL", "Paesi Bassi"], ["LU", "Lussemburgo"], ["IE", "Irlanda"],
];

export const FREE_SHIPPING = 80;
export const SHIPPING_FEE = 6.9;
